/**
 * Generates a unique certificate number in the format: PREFIX/DDMMYYYY/SEQ
 * Sequence is tracked per prefix per day using localStorage.
 * Example: generateCertNo('MLCF3') → "MLCF3/26042026/001"
 *
 * A 5-second in-memory cache prevents React Strict Mode's intentional
 * double-mount from incrementing the counter twice per page open.
 */
const _cache = new Map(); // prefix → { certNo, timestamp }

export const generateCertNo = (prefix) => {
  const now = Date.now();
  const cached = _cache.get(prefix);

  // Return cached value if requested again within 5 seconds (Strict Mode guard)
  if (cached && now - cached.timestamp < 5000) {
    return cached.certNo;
  }

  const d = new Date();
  const dd      = String(d.getDate()).padStart(2, '0');
  const mm      = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy    = d.getFullYear();
  const dateStr = `${dd}${mm}${yyyy}`;

  const key  = `certSeq_${prefix}_${dateStr}`;
  const next = parseInt(localStorage.getItem(key) || '0') + 1;
  localStorage.setItem(key, String(next));

  const certNo = `${prefix}/${dateStr}/${String(next).padStart(3, '0')}`;
  _cache.set(prefix, { certNo, timestamp: now });
  return certNo;
};
